<div class="container">
  <div class="left">
    <mat-checkbox (change)="onCheckedItem($event)">
    </mat-checkbox>
  </div>
  <div  class="list" (click)="onClickEditModiferGroup()">
    <div class="item" >
      <div>
        {{modifierGroup.name}}
      </div>
      <div>
        {{modifierGroup.description}}
      </div>
    </div>
    <div class="item">
      <div>modifiers:</div>
      <div *ngFor="let modifier of modifierGroup.modifierProducts"> {{ GetModifierName(modifier.modifierId) }} </div>
    </div>
  </div>

  <div class="right">
    <button (click)="onClickDelete()" class="mat-button">
      <mat-icon aria-label="Clear" mat-icon-button matSuffix>delete</mat-icon>
    </button>
  </div>
</div>
